module.exports = __webpack_public_path__ + "img/dk.b674c738.png";